import { BaselineSection } from '../BaselineSection';
import { type StepForm, WizardField } from '../WizardField';

interface Props {
  form: StepForm;
}

const BASELINE_FIELDS = [
  {
    name: 'step3.baselineDirectJobs',
    label: 'Existing direct jobs (FTE)',
    step: 1,
  },
  {
    name: 'step3.baselineDirectAnnualPayroll',
    label: 'Existing annual payroll',
    format: 'currency' as const,
  },
];

export function Step3Employment({ form }: Props) {
  const projectType = form.watch('step1.projectType');
  return (
    <div className="space-y-4">
      <div>
        <h3 className="text-base font-semibold text-slate-800">Employment</h3>
        <p className="mt-0.5 text-sm text-slate-500">
          Direct full-time-equivalent jobs and payroll at full stabilization.
        </p>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <WizardField
          form={form}
          name="step3.directJobs"
          label="Direct jobs (FTE at stabilization)"
          type="number"
          min={0}
          step={1}
        />

        <WizardField
          form={form}
          name="step3.directAnnualPayroll"
          label="Annual payroll at stabilization"
          format="currency"
        />

        <div className="col-span-2">
          <p className="mb-2 text-sm font-medium text-slate-700">Staffing ramp-up</p>
          <div className="grid grid-cols-2 gap-4">
            <WizardField
              form={form}
              name="step3.staffingRampYear1"
              label="Year 1"
              format="percent"
              min={0}
              max={1}
              step={0.05}
              hint="Headcount as % of full stabilization"
            />

            <WizardField
              form={form}
              name="step3.staffingRampYear2"
              label="Year 2"
              format="percent"
              min={0}
              max={1}
              step={0.05}
              hint="Year 3+ assumed at 100%"
            />
          </div>
        </div>
      </div>

      <BaselineSection form={form} projectType={projectType} fields={BASELINE_FIELDS} />
    </div>
  );
}
